<template>
  <aha-accordion class="share-accordion">
    <aha-accordion-item
      v-if="!isShowShareACopyList"
      :default-expanded="!defaultExpandedAccordion"
    >
      <template slot="title">
        <h5 class="flex items-center text-secondary-100">
          <aha-icon-container
            class="mr-2 font-bold truncate cursor-pointer"
            size="md"
            icon-class="bg-secondary-40 text-base-0"
          >
            <aha-icon
              name="phone"
              width="16"
              height="16"
              viewBox="0 0 16 16"
            />
          </aha-icon-container>
          Share to participants
        </h5>
      </template>
      <template slot="content">
        <InviteParticipants :showHeader="false" />
      </template>
    </aha-accordion-item>

    <aha-accordion-item v-if="!isShowShareACopyList && showPublicCommunity">
      <template slot="title">
        <h5 class="flex items-center text-secondary-100" @click="clickedPublishTemplateTab">
          <aha-icon-container
            class="mr-2 font-bold truncate cursor-pointer"
            size="md"
            icon-class="bg-secondary-40 text-base-0"
          >
            <aha-icon
              name="inspiration"
              width="16"
              height="16"
              viewBox="0 0 24 24"
            />
          </aha-icon-container>
          Publish to Template Library
        </h5>
      </template>
      <template slot="content">
        <ShareToCommunity
          from="presentation-detail"
          :presentation="presentation"
        />
      </template>
    </aha-accordion-item>

    <aha-accordion-item
      :class="{ 'showing-share-a-copy-list': isShowShareACopyList }"
      :has-default-styling="!isShowShareACopyList"
      :default-expanded="defaultExpandedAccordion === 'shareToCopy'"
    >
      <template slot="title">
        <h5 class="flex items-center text-secondary-100">
          <aha-icon-container
            class="mr-2 font-bold truncate cursor-pointer"
            size="md"
            icon-class="bg-secondary-40 text-base-0"
          >
            <aha-icon
              name="duplicated"
              width="14"
              height="14"
              viewBox="0 0 18 18"
            />
          </aha-icon-container>
          Share a copy
        </h5>
      </template>
      <template slot="content">
        <ShareACopy
          :hide-title="true"
          :presentation="presentation"
          @handle-hide-main-header="handleHideMainHeader()"
          @handleShowSendACopyDialog="handleShowSendACopyDialog"
        />
      </template>
    </aha-accordion-item>
  </aha-accordion>
</template>

<script>
import { mapState } from 'vuex'

import ShareACopy from '@/components-v2/presentation-editor/collaboration/ShareACopy.vue'
import ShareToCommunity from '@/components-v2/presentation-editor/editor-header/ShareToCommunity.vue'
import InviteParticipants from '@/components-v2/presentation-editor/editor-header/InviteParticipants.vue'
import Utils from '@/util'
import Config from '@/config'
import constants from '@/constant'
import gaCategories from '@/constant/gaCategories'

export default {
  components: {
    InviteParticipants,
    ShareToCommunity,
    ShareACopy,
  },
  props: {
    presentation: {
      type: Object,
      required: true,
    },
    isShowShareACopyList: {
      type: Boolean,
      required: true,
    },
    handleHideMainHeader: {
      type: Function,
      required: true,
    },
    handleShowSendACopyDialog: {
      type: Function,
      required: true,
    },
    defaultExpandedAccordion: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
    }),
    showPublicCommunity() {
      if (!this.currentUser.email || Config.region === constants.euRegion
        || this.currentUser.isDisablePublicTemplate) {
        return false
      }
      return true
    },
  },
  methods: {
    clickedPublishTemplateTab() {
      Utils.gaTrackEvent(
        gaCategories.PRESENTATION_EDITOR,
        'Switch to Share Community tab',
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.showing-share-a-copy-list {
  & ::v-deep .accordion-item-title {
    @apply hidden;
  }
}

.share-accordion {
  & ::v-deep {
    .accordion-item--expanded {
      .share-accordion__badge {
        display: none;
      }
    }
  }
}
</style>
